import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink as RouterNavLink, matchPath, useLocation, useRouteMatch, } from 'react-router-dom';
import classNames from 'classnames';
import { push } from 'connected-react-router';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useActiveGameSelector, useGameBalanceSelector } from '~slices/games';
import { LOGIN_PRESS } from '~constants/cpa-message-codes';
import { MODALS, closeModal, openModal } from '~modals';
import { isAuthenticatedSelector, isCookieAcceptedSelector, resetRegistrationErrors, } from '~slices/auth';
import { changeLocalSportId, changeSportId, selectHeaderSportUid, sportNameSelector, } from '~slices/options';
import { cashOutDataSelector, loadingCashOutSelector } from '~slices/cashOut';
import { Button, Live } from '~atoms';
import { useAppDispatch } from '~store/configureStore';
import { availableSportsSelector, mapSportUidToSportIcon, } from '~slices/sports';
import { LanguageSelector, UserDropdownMenu } from '~organisms';
import { currencyConverter } from '~utils/converters';
import logo from '~icons/logo.svg';
import TipGameLogo from '~icons/TipGame-logo.png';
import logoTurkey from '~icons/logoTurkey.svg';
import { defaultCountryCodeSelector, getLocale as getLocaleAsyncAction, } from '~slices/locale';
import { useBreakpoint, usePlatofrmType, useStructuredSelector } from '~hooks';
import { SoccerIcon } from '~icons';
import { accountInfoSelector } from '~slices/account';
import { PLATFORMS } from '~slices/teasers';
import { changeHintState } from '~slices/hints';
import { getGameName } from '~utils/getGameName';
import { getTestId } from '~utils/getTestId';
import { getPathWithLanguageCode } from '~utils/languageInURL/getPathWithLanguageCode';
import { isBetCheckProject } from '~utils/constants/betCheckConstants';
import { CSIcon } from '~icons/rankingList/CSIcon';
import { PaymentsURL } from '~pages/payments/payments.routes';
import { useHeaderStyles } from './Header.styles';
import { MYBETS_FOR_UNLOGGED_BREAKPOINT } from './constants';
export var NavLink = function (_a) {
    var _b;
    var label = _a.label, to = _a.to, activeOnlyWhenExact = _a.activeOnlyWhenExact, icon = _a.icon, className = _a.className, additionalIcon = _a.additionalIcon, state = _a.state, active = _a.active, onClick = _a.onClick, dataTestId = _a.dataTestId;
    var match = useRouteMatch({
        path: to,
        exact: activeOnlyWhenExact,
    });
    var headerClasses = useHeaderStyles();
    return (React.createElement(RouterNavLink, { to: {
            pathname: to ? getPathWithLanguageCode(to) : undefined,
            state: state,
        }, onClick: onClick, "data-testid": getTestId(dataTestId), className: classNames(className, (_b = {},
            _b[headerClasses.active] = typeof active === 'boolean' ? active : match,
            _b), 'flex-row flex-center justify-center') },
        React.createElement("li", { className: "flex-row flex-center" },
            icon,
            label ? (React.createElement("span", { className: classNames(headerClasses.link, headerClasses.linkLabel, headerClasses.paddings) }, label)) : null,
            additionalIcon || null)));
};
export var DesktopHeader = function () {
    var _a, _b;
    var dispatch = useAppDispatch();
    var platform = usePlatofrmType();
    var _c = useStructuredSelector({
        accountInfo: accountInfoSelector,
        gameBalance: useGameBalanceSelector,
        countryCode: defaultCountryCodeSelector,
        isAuthenticated: isAuthenticatedSelector,
        currentSportUid: selectHeaderSportUid,
        cashOutLoadingStatus: loadingCashOutSelector,
        cashoutData: cashOutDataSelector,
        cookieAccepted: isCookieAcceptedSelector,
        activeGame: useActiveGameSelector,
        sports: availableSportsSelector,
        sportName: sportNameSelector,
    }), accountInfo = _c.accountInfo, gameBalance = _c.gameBalance, isAuthenticated = _c.isAuthenticated, currentSportUid = _c.currentSportUid, cashOutLoadingStatus = _c.cashOutLoadingStatus, _d = _c.cashoutData, _e = _d.cashout, cashout = _e === void 0 ? 0 : _e, _f = _d.currency, currency = _f === void 0 ? '' : _f, cookieAccepted = _c.cookieAccepted, activeGame = _c.activeGame, countryCode = _c.countryCode, sports = _c.sports, sportName = _c.sportName;
    var location = useLocation();
    var match = useRouteMatch();
    // TODO, change on data from BE
    var isBetCheck = isBetCheckProject;
    var t = useTranslation(['header', 'tip-game']).t;
    var shouldDisplayMybetsForUnlogged = useBreakpoint(MYBETS_FOR_UNLOGGED_BREAKPOINT);
    var isTopRankingPage = location.pathname === '/top-ranking';
    var isBetPartnersPage = location.pathname === '/bp-list';
    var getIsActiveLink = function (toPath) {
        // "toPath" is the path goal without a slash
        return window.location.pathname.split('/')[2] === toPath;
    };
    var _g = useState({
        cashOutBalance: cashout,
        cashOutCurrency: currency,
    }), localCashout = _g[0], setLocalCashout = _g[1];
    var gameBalanceValue = (gameBalance === null || gameBalance === void 0 ? void 0 : gameBalance.balance) !== undefined
        ? gameBalance.balance
        : gameBalance === null || gameBalance === void 0 ? void 0 : gameBalance.startCredits;
    var cashOutBalance = localCashout.cashOutBalance, cashOutCurrency = localCashout.cashOutCurrency;
    var balance = isBetCheck ? cashOutBalance : gameBalanceValue;
    var cashOut = currencyConverter(balance, cashOutCurrency);
    var Icon = (currentSportUid && mapSportUidToSportIcon[currentSportUid]) || SoccerIcon;
    var headerClasses = useHeaderStyles();
    var chooseToShow = function () {
        if (isBetCheck && countryCode && countryCode === 'TR')
            return logoTurkey;
        if (isBetCheck && countryCode !== 'TR')
            return logo;
        if (!isBetCheck)
            return TipGameLogo;
        return '';
    };
    var openRegistrationModal = function () {
        if (!cookieAccepted) {
            dispatch(changeHintState({ isCookiesConsentHintEnabled: true }));
        }
        if (cookieAccepted || platform === PLATFORMS.CROSS_PLATFORM_MOBILE) {
            var language = i18next.language;
            dispatch(getLocaleAsyncAction(language)).then(function () {
                dispatch(openModal({
                    modalName: MODALS.REGISTRATION_MODAL,
                    modalProps: {
                        isOpen: true,
                        onClose: function () {
                            dispatch(resetRegistrationErrors());
                            dispatch(closeModal({ key: MODALS.REGISTRATION_MODAL }));
                        },
                    },
                }));
            });
        }
    };
    var shouldRedirectToOptions = useRef(false);
    var openLoginModal = function (fromMyBets) {
        var _a;
        var pathToRedirect = (shouldRedirectToOptions.current && 'options') ||
            (fromMyBets && "".concat(PaymentsURL.PROFILE)) ||
            (isTopRankingPage && 'top-ranking') ||
            (isBetPartnersPage && 'bp-list') ||
            'home/all/live';
        if (cookieAccepted) {
            dispatch(openModal({
                modalName: MODALS.LOGIN_MODAL,
                modalProps: {
                    isOpen: true,
                    onClose: function () {
                        shouldRedirectToOptions.current = false;
                        dispatch(closeModal({ key: MODALS.LOGIN_MODAL }));
                    },
                    onSubmit: function () {
                        var path = '/:lng/home/:sportName/:flagName/:tournamentName';
                        var match = matchPath(window.location.pathname, {
                            path: path,
                        });
                        var sportName = match === null || match === void 0 ? void 0 : match.params.sportName;
                        var flagName = match === null || match === void 0 ? void 0 : match.params.flagName;
                        var matchedURL = '';
                        if (sportName && sportName !== 'all' && flagName) {
                            matchedURL = match.url;
                            var sportFromURL = sports.find(function (sport) {
                                return (sport === null || sport === void 0 ? void 0 : sport.name) === decodeURI(sportName || '') ||
                                    (sport === null || sport === void 0 ? void 0 : sport.id) === Number(sportName);
                            });
                            dispatch(changeSportId(sportFromURL === null || sportFromURL === void 0 ? void 0 : sportFromURL.id));
                        }
                        else {
                            dispatch(dispatch(changeLocalSportId({
                                id: null,
                                desktop: true,
                                langIso: i18next.language,
                            })));
                        }
                        dispatch(closeModal({ key: MODALS.LOGIN_MODAL }));
                        var finalPath = matchedURL
                            ? "".concat(matchedURL).concat(pathToRedirect)
                            : "".concat(pathToRedirect);
                        dispatch(push(getPathWithLanguageCode(finalPath)));
                    },
                },
            }));
        }
        else if (platform === PLATFORMS.CROSS_PLATFORM_MOBILE) {
            (_a = window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({
                code: LOGIN_PRESS,
                target: "/".concat(pathToRedirect),
            }));
            shouldRedirectToOptions.current = false;
        }
        else {
            shouldRedirectToOptions.current = false;
            dispatch(changeHintState({ isCookiesConsentHintEnabled: true }));
        }
    };
    useEffect(function () {
        if (cashOutLoadingStatus === 'fulfilled') {
            setLocalCashout({
                cashOutBalance: cashout,
                cashOutCurrency: currency,
            });
        }
    }, [cashOutLoadingStatus]);
    var LogoClickHandler = function () {
        isBetCheck
            ? dispatch(push(getPathWithLanguageCode('/home')))
            : dispatch(push(getPathWithLanguageCode('/start')));
    };
    var myBetsLoginHandler = function () {
        openLoginModal(true);
    };
    var handleOptionsClick = function () {
        if (!isAuthenticated) {
            shouldRedirectToOptions.current = true;
            openLoginModal();
        }
    };
    useEffect(function () {
        if (isAuthenticated && shouldRedirectToOptions.current) {
            shouldRedirectToOptions.current = false;
            setTimeout(function () {
                dispatch(push(getPathWithLanguageCode("".concat(match === null || match === void 0 ? void 0 : match.url, "options"))));
            });
        }
    }, [isAuthenticated]);
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { src: chooseToShow(), alt: "logo", "data-testid": getTestId('HAM_MENU'), className: classNames((_a = {},
                _a[headerClasses.desktopLogo] = true,
                _a.turkey = countryCode === 'TR' && isBetCheck,
                _a), !isBetCheck && headerClasses.tipGameDesktopLogo), onClick: LogoClickHandler }),
        isBetCheck && (React.createElement(NavLink, { label: t('header:our_bp_partners'), to: getPathWithLanguageCode('/bp-list'), icon: React.createElement(React.Fragment, null,
                React.createElement("i", { className: "far fa-chart-bar" })), activeOnlyWhenExact: true, className: classNames('relative', headerClasses.headerItem), dataTestId: "BTN_BP_PARTNERS_DESKTOP" })),
        React.createElement(NavLink, { label: t('header:options'), to: isAuthenticated ? getPathWithLanguageCode('/options') : undefined, onClick: handleOptionsClick, active: getIsActiveLink('options'), className: headerClasses.headerItem, icon: React.createElement("i", { className: "far fa-cog" }) }),
        React.createElement(NavLink, { active: isTopRankingPage || getIsActiveLink('home'), label: t('header:betting'), to: getPathWithLanguageCode("/home/all/live/".concat(sportName === null || sportName === void 0 ? void 0 : sportName.name)), icon: React.createElement(Icon, { viewBox: "0 0 18 18" }), className: classNames('relative', headerClasses.headerItem), additionalIcon: React.createElement(Live, { className: headerClasses.topIcon }), dataTestId: "BTN_SELECTION" }),
        !isAuthenticated ? (React.createElement(NavLink, { label: t('header:beton'), to: getPathWithLanguageCode('/about/betcheck/about_us'), state: {
                aboutVideoAutoplay: true,
            }, active: location.pathname.includes('/about/tipgame/') ||
                location.pathname.includes('/about/info/'), className: headerClasses.headerItem, icon: React.createElement("i", { className: "fas fa-play-circle" }) })) : null,
        React.createElement("div", { className: classNames(headerClasses.rigthContainer, (_b = {},
                _b[headerClasses.unlogged] = !isAuthenticated,
                _b)) },
            !isAuthenticated ? (React.createElement(Button, { className: headerClasses.registerButton, variant: "contained", onClick: openRegistrationModal, "data-testid": getTestId('BTN_REGISTER') }, t('header:register'))) : (React.createElement("span", null)),
            !isAuthenticated ? (React.createElement(Button, { className: headerClasses.loginButton, "data-testid": getTestId('BTN_LOGIN'), onClick: function () { return openLoginModal(); }, variant: "contained" }, t('header:login'))) : (React.createElement(UserDropdownMenu, { t: t })),
            React.createElement(LanguageSelector, null),
            isAuthenticated && accountInfo.purchased ? (React.createElement("div", { className: "relative" },
                React.createElement(Button, { variant: "contained", component: Link, to: getPathWithLanguageCode("/".concat(PaymentsURL.PROFILE)), className: headerClasses.desktopCashOutButton, "data-testid": getTestId('BTN_MY_BETS') },
                    React.createElement("span", { className: headerClasses.cashOutLabel }, getGameName(activeGame)),
                    React.createElement("span", { className: headerClasses.cashOutButtonBalance },
                        React.createElement("span", null, cashOut),
                        isBetCheck ? cashOutCurrency : React.createElement(CSIcon, { size: "md" }))))) : null,
            isAuthenticated && !accountInfo.purchased ? (React.createElement("div", { className: "relative" },
                React.createElement(Button, { variant: "contained", component: Link, to: getPathWithLanguageCode("/".concat(PaymentsURL.PROFILE)), className: headerClasses.desktopCashOutButton, "data-testid": getTestId('BTN_MY_BETS') }, isBetCheck ? t('header:my_bets') : t('tip-game:my-tips.my_tips')))) : null,
            !isAuthenticated && shouldDisplayMybetsForUnlogged ? (React.createElement(Button, { variant: "contained", onClick: myBetsLoginHandler, className: headerClasses.desktopCashOutButton, "data-testid": getTestId('BTN_MY_BETS') }, isBetCheck ? t('header:my_bets') : t('tip-game:my-tips.my_tips'))) : null)));
};
